import { Api } from "../../api/Api";
import { ResponsibleGamingOptionType } from "../../api/common/model/enum/ResponsibleGamingOptionType";
import { GetSettingsParams } from "../../api/responsiblegaming/GetSettingsParams";
import { SetSettingsParams } from "../../api/responsiblegaming/SetSettingsParams";
import { SetTriggerParams } from "../../api/responsiblegaming/SetTriggerParams";
import { AppEvent } from "../Constants";
import { AbstractGameController } from "./AbstractGameController";
import { CommonGameEvent } from "./event/CommonGameEvent";
/**
 * SettingsController.ts
 */
export class SettingsController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.RESPONSIBLE_GAMING_CANCEL_SETTINGS, this.handleCancelSettings);
        this.registerGame(CommonGameEvent.RESPONSIBLE_GAMING_SAVE_SETTINGS, this.handleSaveSettings);
        this.registerGame(CommonGameEvent.RESPONSIBLE_GAMING_SET_TRIGGER, this.handleSetTrigger);
    }
    getSettings() {
        if (this.responsibleGaming.isEnabled()) {
            let params = new GetSettingsParams(this.baseModel.getRoomName());
            Api.getResponsibleGamingSettings(params, this.handleGetSettingsResult, this);
        }
        else {
            this.handleComplete();
        }
    }
    handleCancelSettings() {
        this.responsibleGaming.cancel();
    }
    handleSaveSettings() {
        if (this.responsibleGaming.isModified()) {
            let roomName = this.baseModel.getRoomName();
            let extraSpin = this.getOption(ResponsibleGamingOptionType.EXTRA_SPIN);
            let spinPrice = this.getOption(ResponsibleGamingOptionType.SPIN_PRICE);
            let singleGameStake = this.getOption(ResponsibleGamingOptionType.SINGLE_GAME_STAKE);
            let maximumLoss = this.getOption(ResponsibleGamingOptionType.MAXIMUM_LOSS);
            let hideInstructions = this.responsibleGaming.isHideInstructions();
            let params = new SetSettingsParams(roomName, extraSpin, spinPrice, singleGameStake, maximumLoss, hideInstructions);
            Api.setResponsibleGamingSettings(params, this.handleSetSettingsResult, this);
        }
    }
    handleSetTrigger() {
        let roomName = this.baseModel.getRoomName();
        let gameInstanceId = this.responsibleGaming.getGameInstanceId();
        let trigger = this.responsibleGaming.getTrigger();
        let triggerValue = this.getOption(trigger);
        let params = new SetTriggerParams(roomName, gameInstanceId, trigger.getId(), triggerValue);
        Api.setResponsibleGamingTrigger(params, this.handleSetTriggerResult, this);
    }
    handleGetSettingsResult(result) {
        if (this.isSuccess(result.getResponseCode())) {
            let response = result.getData();
            this.updateSettings(response.getSettings());
        }
        this.handleComplete();
    }
    handleSetSettingsResult(result) {
        if (this.isSuccess(result.getResponseCode())) {
            let response = result.getData();
            this.updateSettings(response.getSettings());
        }
    }
    handleSetTriggerResult(result) {
        if (this.isSuccess(result.getResponseCode())) {
            let response = result.getData();
            this.updateSettings(response.getSettings());
        }
    }
    updateSettings(settings) {
        if (this.responsibleGaming.isEnabled()) {
            if (settings != null) {
                this.responsibleGaming.setSettings(settings);
            }
        }
    }
    handleComplete() {
        this.dispatchCore(AppEvent.SETTINGS_LOADED);
    }
    getOption(type) {
        let value = ResponsibleGamingOptionType.INACTIVE;
        if (this.responsibleGaming.isOptionActive(type)) {
            let data = this.responsibleGaming.getActiveOption(type);
            value = data.getValue();
        }
        return value;
    }
    run() {
        if (!this.running) {
            super.run();
            this.getSettings();
        }
    }
}
//# sourceMappingURL=SettingsController.js.map